<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户名或手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="状态" prop="status" >
                <a-select  v-model="queryParam.status">
                  <a-select-option :value="0">禁用</a-select-option>
                  <a-select-option :value="1">正常</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:user:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:user:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:user:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:user:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />


      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="coinNum" slot-scope="text, record">
          <a @click="userCoinBalance(record)"> <a-icon />{{ record.coinNum }} </a>
        </span>
        <span slot="revenue" slot-scope="text, record">
          <a @click="userRevenue(record)"> <a-icon />{{ record.revenue }} </a>
        </span>

        <span slot="inviteCount" slot-scope="text, record">
          <a @click="userInvite(record)"> <a-icon />{{ record.inviteCount }} </a>
        </span>

        <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.avatar"
                :src="processImageUrl(record.avatar)" preview="头像"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record,undefined)"v-hasPermi="['zb:user:edit']">
            <a-icon type="edit" />编辑
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageUser, listUser, delUser, updateUser} from '@/api/user/user'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'User',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      names: '',
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      open: false,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        password: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        email: null,
        realName: null,
        idCard: null,
        authenticationStatus: null,
        reject: null,
        userSign: null,
        isNotice: null,
        aliQr: null,
        aliName: null,
        wxQr: null,
        wxName: null,
        money: null,
        allMoney: null,
        accessNum: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '用户编号',
        //   dataIndex: 'id',
        //   align: 'center',
        // },
        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'image'}
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '邮箱',
        //   dataIndex: 'email',
        //   ellipsis: true,
        //   align: 'center'
        // },

        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return '男'
            }else if (f ==2){
              return '女'
            }else{
              return '保密'
            }
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return '正常'
            }else if (f ==0){
              return '禁用'
            }
          }
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    processImageUrl,
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onClose() {
      this.open = false
    },

    userCoinBalance(record){
      this.open = true
      this.names = 'coinBalance'
      this.$nextTick(() => {
        this.$refs.coinBalance.goList(record)
      })
    },

    userRevenue(record){
      this.open = true
      this.names = 'revenue'
      this.$nextTick(() => {
        this.$refs.revenue.goList(record)
      })
    },


    userInvite(record){
      this.open = true
      this.names = 'invite'
      this.$nextTick(() => {
        this.$refs.invite.goList(record)
      })
    },

    handleCancel(record,status){
      let that = this
      if(status == 0 ){
        this.$confirm({
          title: '确认冻结所选中数据?',
          content: '当前选中编号为' + record.id + '的数据',
          onOk () {
            return updateUser({id:record.id,status:status})
              .then(() => {
                that.getList()
                that.$message.success(
                  '操作成功',
                  3
                )
              })
          },
          onCancel () {
            //取消清空删除ids列表

          }
        })
      }else{
        updateUser({id:record.id,status:status})
          .then(() => {
            that.getList()
            that.$message.success(
              '操作成功',
              3
            )
          })
      }

    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        password: undefined,
        avatar: undefined,
        nickname: undefined,
        sex: undefined,
        birthday: undefined,
        email: undefined,
        realName: undefined,
        idCard: undefined,
        authenticationStatus: undefined,
        reject: undefined,
        userSign: undefined,
        isNotice: undefined,
        aliQr: undefined,
        aliName: undefined,
        wxQr: undefined,
        wxName: undefined,
        money: undefined,
        allMoney: undefined,
        accessNum: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
